import { createContext, useContext } from "react";

/** Carries a surface's layout scale to its portalled controls. */
export const UiScaleContext = createContext(1);
export const useUiScale = () => useContext(UiScaleContext);
